import { useCallback } from 'react';
import { useGetDisplayWebContentSelector } from './useGetDisplayWebContentSelector';

export const useGetDisplaySegmentationSelector = () => {
  const getDisplayWebContent = useGetDisplayWebContentSelector();
  return useCallback((id: string) => getDisplayWebContent(id)?.segmentationRules, [getDisplayWebContent]);
};
